<div class="_flex _flex-col _h-full _max-h-[90vh]">
    <div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
        <div class="_text-h4 sm:_text-h3 _heading">Booking Summary</div>
        <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
    </div>

    <mat-dialog-content class="_flex-1 _min-h-0 _overflow-y-scroll _scrollbar _scrollbar-thin _scrollbar-track-gray-100 _scrollbar-thumb-gray-300 _pr-4">
      <div class="_py-8">
        <div class="_h4 _mb-4 _font-bold">Trip Details</div>
        <dl class="_grid _grid-cols-1 xs:_grid-cols-2 _gap-y-2">
            <dt>Property name:</dt>
            <dd class="_font-bold">{{ data.listingName }}</dd>
            <dt>Check-in:</dt>
            <dd class="_font-bold">{{ checkin }}</dd>
            <dt>Check-out:</dt>
            <dd class="_font-bold">{{ checkout }}</dd>
            <dt>Total stay:</dt>
            <dd class="_font-bold">{{ data.travelDates.nights }} nights</dd>
            <dt>Total guests:</dt>
            <dd class="_font-bold">{{ data.totalGuests }}</dd>
        </dl>

        <ng-container *ngIf="data.commissionRate">
            <div class="_h4 _mb-4 _mt-8 _font-bold">
              <span *ngIf="!data.consumerView">Fees & Commissions</span>
              <span *ngIf="data.consumerView">Fees</span>
            </div>
            <dl class="_grid _grid-cols-2 _gap-y-2">
                <dt>Client pays:</dt>
                <dd class="_font-bold">{{ data.price }}</dd>
                <ng-container *ngIf="!data.consumerView">
                  <dt>Your commission:</dt>
                  <dd class="_flex _items-center _font-bold">
                      <span class="_pill-thin">{{data.commissionRate}}%</span>
                      <span class="_px-1">/</span>
                      <div *ngIf="(data.commissionAmount$ | async) as totalCommission">
                          {{ (totalCommission.amountMicros / 1000000) | currency: totalCommission.currency : 'symbol-narrow' : '1.0-0' }}
                      </div>
                  </dd>
                </ng-container>
                <ng-container *ngIf="data.ZARListing">
                    <dt>You will be charged in ZAR</dt>
                    <dd class="_font-bold">{{ data.priceInListingCurrency }}</dd>
                </ng-container>
            </dl>
        </ng-container>

        <div class="_h4 _mb-4 _mt-8 _font-bold">Payment Process</div>
        <p>We will place a payment hold on the payment card. You will not be charged until the hotel confirms the booking.</p>

        <div class="_my-4">
            <ng-container *ngIf="data.installmentSchedule; else fullPayment">
                <div class="_h4 _mb-4 _mt-8 _font-bold">Payment Schedule Breakdown</div>
                <!-- Installment Amount Display -->
                <div class="_mt-4 _space-y-3">
                    <div *ngFor="let installment of data.installmentSchedule.installments; let i = index"
                          class="_bg-gray-50 _rounded-lg _p-4 _flex _flex-col xs:_flex-row _justify-between _items-center _gap-2">
                        <div class="_flex-1 _w-full xs:_w-auto">
                            <div class="_text-gray-900 _font-medium">
                                {{ formatDaysPrior(installment.daysPriorTo) | titlecase }}
                            </div>
                            <div class="_text-xs _text-gray-600">Payment Installment {{ i + 1 }} / {{ data.installmentSchedule.installments.length }}</div>
                        </div>
                        <div class="_flex _flex-col xxs:_flex-row _items-end xxs:_items-center _gap-2 _w-full xs:_w-auto _text-right _justify-end _mt-2 xxs:_mt-0">
                            <div class="_text-black _font-bold">
                                {{ getInstallmentAmount(installment.percentage) }}
                            </div>
                            <div class="_text-sm _text-gray-500">
                                {{ installment.percentage }}%
                            </div>
                            <span *ngIf="isPaymentDueNow(installment.daysPriorTo)"
                                class="_pill _pill-thin _bg-primary-1 _text-white _text-sm xs:_text-base _font-bold">
                                Due now
                            </span>
                        </div>
                    </div>
                </div>
    
                <!-- Commission Breakdown (if applicable) -->
                <div *ngIf="data.commissionRate && !data.consumerView" class="_mt-4 _pt-4 _border-t _border-transparency-black-5">
                    <div class="_h4 _mb-4 _mt-8 _font-bold">Your Commission Breakdown</div>
                    <div class="_space-y-3">
                        <div *ngFor="let installment of data.installmentSchedule.installments; let i = index"
                              class="_bg-gray-50 _rounded-lg _p-4 _flex _flex-col xs:_flex-row _justify-between _items-center _gap-2">
                            <div class="_flex-1 _w-full xs:_w-auto">
                                <div class="_text-gray-900 _font-medium">
                                    {{ formatDaysPrior(installment.daysPriorTo) | titlecase }}
                                </div>
                                <div class="_text-xs _text-gray-600">Commission Installment {{ i + 1 }} / {{ data.installmentSchedule.installments.length }}</div>
                            </div>
                            <div class="_flex _flex-col xxs:_flex-row _items_end xxs:_items-center _justify-end _gap-2 _w-full xs:_w-auto _text-right">
                                <div class="_text-black _font-bold">
                                    {{ getInstallmentAmount(installment.percentage * Number(data.commissionRate) / 100) }}
                                </div>
                                <div class="_text-sm _text-gray-500">
                                    {{ data.commissionRate }}% of Installment #{{ i + 1 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
    
            <ng-template #fullPayment>
                <div class="_grid _grid-cols-3 _gap-2 _bg-gray-50 _rounded-lg _p-4 _text-black">
                    <div>Due upon confirmation</div>
                    <div>100%</div>
                    <div class="_font-bold">{{ data.price }}</div>
                </div>
            </ng-template>
    
            <ng-container *ngIf="false">
                <div class="_h4 _mb-4 _mt-8 _font-bold">Cancellation Policy</div>
                <p>See the full cancellation policy <a href="" class="_link _inline _underline">here</a>.</p>
            </ng-container>
        </div>
      </div>
    </mat-dialog-content>

    <!-- Footer pushed to bottom using flex -->
    <div class="_mt-auto _bg-white _flex _flex-col xs:_flex-row _justify-end _gap-2 _p-4 _pb-0 _border-t _border-gray-200">
        <app-button
            class="_w-full xs:_w-max"
            modifierClassNames="_w-full"
            type="primary"
            [onClick]="confirm.bind(this)"
            [loading]="loadingCheckout">
            Proceed to checkout
        </app-button>
        <button class="_button-primary _w-full xs:_w-max" (click)="decline()">Edit booking</button>
    </div>
</div>
